import React from "react";

const Ethereum = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_3911_36236)">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#627EEA"
        />
        <path
          d="M10.3115 2.5V8.04375L14.9971 10.1375L10.3115 2.5Z"
          fill="white"
          fill-opacity="0.602"
        />
        <path
          d="M10.3112 2.5L5.625 10.1375L10.3112 8.04375V2.5Z"
          fill="white"
        />
        <path
          d="M10.3115 13.7303V17.4971L15.0003 11.0103L10.3115 13.7303Z"
          fill="white"
          fill-opacity="0.602"
        />
        <path
          d="M10.3112 17.4971V13.7296L5.625 11.0103L10.3112 17.4971Z"
          fill="white"
        />
        <path
          d="M10.3115 12.858L14.9971 10.1374L10.3115 8.04492V12.858Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M5.625 10.1374L10.3112 12.858V8.04492L5.625 10.1374Z"
          fill="white"
          fill-opacity="0.602"
        />
      </g>
      <defs>
        <clipPath id="clip0_3911_36236">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Ethereum;
